import { GamePlace } from 'constants/cards';
import { DROP_Z_INDEX, COLUMN_Z_INDEX } from 'constants/layout';
import { DEAL_DELAY, CARD_DEAL_MOVE_TIME } from 'constants/move';
import { Column } from './Column';
import { SolitaireGame } from './SolitaireGame';
import { Layout } from './LayoutManager';
import { Power1 } from 'gsap';
import { Card } from 'components/Card';
import { Foundation } from './Foundation';
import { Store } from './store/gameStore';
import { FreeCell } from './FreeCell';

export function drawCardsIntro(solitaireGame: SolitaireGame, cards: string[], onComplete: () => void) {
    const foundations = Layout.foundations;
    const freeCells = Layout.freeCells;
    const columns = Layout.columns;
    cards.forEach((c, i) => {
        const newCard = new Card(c);
        solitaireGame.cards.push(newCard);
        solitaireGame.stockPile.addCard(newCard);
        solitaireGame.gameContainer.addChild(newCard.container);
    });

    if (solitaireGame.stockPile) {
        solitaireGame.stockPile.repositionPlaceholder();
        solitaireGame.stockPile.drawPlaceholder();
    }
    for (let x = 0; x < foundations; x++) {
        const foundation = new Foundation(solitaireGame, x);
        solitaireGame.foundations.push(foundation);
    }
    for (let x = 0; x < freeCells; x++) {
        const freeCell = new FreeCell(solitaireGame, x);
        solitaireGame.freeCells.push(freeCell);
    }

    let lastCardIndex = 0;
    for (let x = 0; x < columns; x++) {
        const newColumn = new Column(solitaireGame, x);
        solitaireGame.columns.push(newColumn);
        const limit = Layout.cardsInColumn(x);
        for (let y = 0; y < limit; y++) {
            let cardIndex = 0;
            let indexRow = y;
            while (indexRow > 0) {
                indexRow--;
                cardIndex += columns - indexRow;
            }
            const index = cardIndex + x;
            lastCardIndex = Math.max(index, lastCardIndex);
            const card = solitaireGame.stockPile.cards.shift();
            if (!card) continue;

            const cardTargetPosition = solitaireGame.columns[x].getCardPosition(y);
            newColumn.addCard(card);

            card.container.zIndex = DROP_Z_INDEX - index;

            card.setPlace({
                cardPlace: GamePlace.TABLEAU,
                value: x,
                zIndex: COLUMN_Z_INDEX + y,
                position: cardTargetPosition,
                order: y,
            });
            const setVisible = Store.isFreecell || y === limit - 1;

            if (setVisible) {
                card.visible = true;
                setTimeout(() => {
                    card.setVisible(true, true);
                }, index * DEAL_DELAY * 1000 + 100);
            }
            card.moveTo(
                cardTargetPosition,
                { ease: Power1.easeInOut, delay: index * DEAL_DELAY, duration: CARD_DEAL_MOVE_TIME },
                () => {
                    card.cardDisplay.castShadow(true);

                    if (index === lastCardIndex) {
                        solitaireGame.stockPile.unblock();
                        solitaireGame.refreshBoard();

                        onComplete();
                    }
                }
            );
        }
    }
}
